import PubSub from 'pubsub-js';
import { useCallback, useEffect, useState } from 'react';

import { useStores } from '../stores';
import { PUBSUB_LAUNCHER_BUTTON_CLICKED } from '../utilities';

export default function useLauncher({ size, offset, position }) {
  const { ui, chatWindow } = useStores();
  const [state, setState] = useState({
    x: 0,
    y: 0
  });

  const toggleOpen = useCallback(() => {
    if (chatWindow.isMinimized) {
      chatWindow.setMode(chatWindow.prevMode);
    } else {
      chatWindow.toggle();
    }

    PubSub.publish(PUBSUB_LAUNCHER_BUTTON_CLICKED, {
      timestamp: new Date(),
      url: window.location.pathname,
      title: document.title
    });
  }, [chatWindow]);

  const toggleMinimize = useCallback(() => {
    if (chatWindow.isMinimized) {
      chatWindow.setMode(chatWindow.prevMode);
    } else {
      chatWindow.minimize();
    }
  }, [chatWindow]);

  useEffect(() => {
    const newState = {
      x: state.x,
      y: state.y
    };

    switch (position) {
      case 'top-right':
        newState.x = ui.windowSize.width - size.width + offset.horizontal;
        newState.y = 0 + offset.vertical;
        break;
      case 'top-left':
        newState.x = 0 + offset.horizontal;
        newState.y = 0 + offset.vertical;
        break;
      case 'bottom-left':
        newState.x = 0 + offset.horizontal;
        newState.y = ui.windowSize.height - size.height + offset.vertical;
        break;
      default:
        newState.x = ui.windowSize.width - size.width + offset.horizontal;
        newState.y = ui.windowSize.height - size.height + offset.vertical;
        break;
    }

    setState(prevState => ({ ...prevState, ...newState }));
  }, [
    offset.horizontal,
    offset.vertical,
    position,
    size.height,
    size.width,
    state.x,
    state.y,
    ui.windowSize.height,
    ui.windowSize.width
  ]);

  return { ...state, toggleOpen, toggleMinimize };
}
